import { render, staticRenderFns } from "./Designers.vue?vue&type=template&id=a36c498e&scoped=true"
import script from "./Designers.vue?vue&type=script&lang=js"
export * from "./Designers.vue?vue&type=script&lang=js"
import style0 from "./Designers.vue?vue&type=style&index=0&id=a36c498e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36c498e",
  null
  
)

export default component.exports